import React from "react";
import { Flexed, Text } from "../styled/shared";
import { Link } from "react-router-dom";

const LegalNav = () => {
  return (
    <Flexed className="mt-4" direction="row" align="center" gap="0.5">
      <Link to="/legal-policies">
        <Text
          pointer
          fontWeight={500}
          type="normal"
          color={
            window.location.pathname.includes("legal-policies")
              ? "black_100"
              : "gray"
          }
        >
          Legal
        </Text>
      </Link>
      <Link to="/seller-aggrement">
        <Text
          pointer
          fontWeight={500}
          type="normal"
          color={
            window.location.pathname.includes("seller-aggrement")
              ? "black_100"
              : "gray"
          }
        >
          Seller Agreement
        </Text>
      </Link>
      <Link to="/privacy-policies">
        <Text
          pointer
          fontWeight={500}
          type="normal"
          color={
            window.location.pathname.includes("privacy-policies")
              ? "black_100"
              : "gray"
          }
        >
          Privacy Policy
        </Text>
      </Link>
    </Flexed>
  );
}
export default LegalNav;